module.exports = __webpack_public_path__ + "static/img/dingding.4c93b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/dingding.png
// module id = KNbV
// module chunks = 0